<script setup lang="ts">
defineOptions({
  name: 'CyclabilityMapPath',
})

const { t } = useI18n()
const navigationStore = useNavigationStore()
const cityStore = useCityStore()
const { slug } = storeToRefs(cityStore)
const { data, mapOptions, loading } = useCyclabilityData({
  excludeMetric: ['network'],
})
const { pathsMetric, availablePathsMetrics } = useCyclabilityRoads(slug)
</script>

<template>
  <MapContainer>
    <Teleport
      v-if="navigationStore.filtersIsMounted"
      to="#teleport-sidebar"
    >
      <DSelectPicker
        v-if="availablePathsMetrics"
        v-model="pathsMetric"
        icon="lines"
        :options="availablePathsMetrics.map(({ name, label }) => ({ value: name, label: label || name }))"
        :label="t('cyclability.filters.segment_metric')"
        :is-loading="loading"
      />

      <CyclabilityMapSettings />
    </Teleport>

    <CyclabilityMapSegments
      v-bind="mapOptions"
      :data="data"
      :is-loading="loading"
      :legend-title="t('City Path Bikeability')"
      @on-zoom="(zoom: number) => {
        mapOptions.zoom = zoom
      }"
    />
  </MapContainer>
</template>
